import { getStoreId } from "$/hooks/use-store-information.ts"
import statsQueries from "$/lib/queries/stats-queries.ts"
import { requireStoreFeature } from "$/lib/require-store-feature.ts"
import { STORE_FEATURE } from "@repo/common"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

/** In the URL so the period survives the reload a store switch causes. */
export const achievementsSearchSchema = z.object({
  year: z.number().int().optional().catch(undefined),
  month: z.number().int().min(0).max(11).optional().catch(undefined),
})

export const Route = createFileRoute("/(app)/_auth/prestationer/")({
  validateSearch: achievementsSearchSchema,
  loaderDeps: ({ search: { year, month } }) => ({ year, month }),
  loader: async ({
    context: { queryClient },
    deps: { year = new Date().getFullYear(), month = null },
  }) => {
    await requireStoreFeature(queryClient, STORE_FEATURE.INSIGHTS)
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(
        statsQueries.achievements(storeId, { year, month }),
      )
    }
    return {
      crumb: "alfred.pages.achievements.crumbs.achievements",
    }
  },
})
